import React from 'react';
import { FaFacebook, FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import "./../assets/css/footer.css"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          {/* Réseaux Sociaux */}
          <div className="col-md-4">
            <h5>Réseaux sociaux</h5>
            <a href="https://www.facebook.com/profile.php?id=61555751753355" className="social-icon"><FaFacebook /></a>
            <a href="https://wa.me/261383385604" className="social-icon"><FaWhatsapp /></a>
          </div>

          {/* Contact */}
          <div className="col-md-4">
            <h5>Contact</h5>
            <p><FaEnvelope /> njachat@gmail.com</p>
            <p><FaPhone /> +261 383385604</p>
          </div>

          {/* Menu */}
          <div className="col-md-4">
            <h5>Menu</h5>
            <a href="/colis" className="footer-link">Suivre votre colis</a>
            <a href="/login" className="footer-link">Se connecter</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
